import styled from 'styled-components'
import Checkbox from '../images/checkbox.png'
import CheckedBox from '../images/icon-checkbox-on.png'

export const ReactTableStyle2 = styled.div`
  width: 100%;
  input[type=checkbox] {
    display: none;
  }
  label { 
    width: 24px;
    height: 24px;
    display: inline-block; 
    cursor: pointer; 
    line-height: 22px; 
    background: url('${Checkbox}') left/22px no-repeat; 
  }
  label.checkbox_active{
    background: url('${CheckedBox}') left/22px no-repeat; 
  }
  table {
    border-spacing: 0;
    margin-top: 20px;
    width: 100%;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th:first-child, td:first-child{
      width: 50px;
    }
    th,
    td {
      text-align: center;
      font-size: 13px;
      margin: 0;
      border-bottom: 1px solid #eee;
      :last-child {
        border-right: 0;
      }
    }
    th {
        height: 40px;
        border-top: 1px solid #eee;
        background-color: #f7f7f7;
        color: #666666;
        font-weight: normal;
        font-size: 12px;
    }
    td {
        height: 50px;
        color: #333333;
    }
  }
`
export const PaginationStyles = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    >  button {
        padding: 0 10px;
        background: none;
        border: none;
        color: #999999;
        font-size: 14px;
        cursor: pointer;
    }
    >  button.active {
        color: #6297ff;
        font-weight: bold;
    }
    > img {
      cursor: pointer;
      margin-right: 6px;
    }
`
export const ReactTableStyle = styled.div`
  width: 100%;
  input[type=checkbox] {
    display: none;
  }
  label { 
    width: 24px;
    height: 24px;
    display: inline-block; 
    cursor: pointer; 
    line-height: 22px; 
    background: url('${Checkbox}') left/22px no-repeat; 
  }
  label.checkbox_active{
    background: url('${CheckedBox}') left/22px no-repeat; 
  }
  table {
    border-spacing: 0;
    width: 100%;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
        height: 60px;
        background-color: #f7f7f7;
        color: #666666;
        font-weight: normal;
    }
    td {
        height: 50px;
        color: #333333;
    }
    th:first-child, td:first-child{
      width: 50px;
    }
    th,
    td {
      text-align: center;
      font-size: 14px;
      margin: 0;
      border-bottom: 1px solid #eee;
      :last-child {
        border-right: 0;
      }
    }
  }
`